import { Text, Flex, Card, Grid } from './TremorCompat';

import {
  Display2ValueToggleItem,
  DisplayItem,
  DisplayPumpSpeed,
  DisplaySliderItem,
  DisplayToggleItem,
  DisplayTimePickerItem,
} from './DisplayItems';

import { GiBoilingBubbles as IconBubbles2 } from 'react-icons/gi';

import {
  MdSpeed as IconSpeed,
  MdOutlineThermostat as IconThermometer,
  MdHotTub as IconSpa,
  MdWbTwighlight as IconLight,
  MdOutlineSchedule as IconClock,
} from 'react-icons/md';

import { COLOURS } from '../styles';
import { offOnOptions, DisableEnableOptions, spaBlowerTimeOutOptions } from '../constants';

import { REGS } from '../registers';

import { formatTemperature } from './RegistersHandler';

export const SPAView = (props) => {
  return (
    <Grid numItems={1} numItemsSm={1} numItemsLg={1} className="gap-4">
      <Card decoration="bottom" decorationColor={COLOURS.cardDecoration} className="mt-3">
        <div className="max-w-none mt-0 space-y-4 text-left">
          <Flex justifyContent="center" alignItems="center" className="space-x-2">
            <Text color={COLOURS.default}>SPA</Text>
          </Flex>
          <Grid numItems={2} numItemsSm={2} numItemsLg={2} className="gap-4">
            <Display2ValueToggleItem
              register={props.onGetRegisterData(REGS.SPA_ENABLE)}
              icon={IconSpa}
              options={DisableEnableOptions}
              onChange={props.handleRegisterUpdate}
              colour={COLOURS.default}
              disabled={props.editOff}
            />
            <Display2ValueToggleItem
              register={props.onGetRegisterData(REGS.SPA_BLOWER_ENABLE)}
              icon={IconSpa}
              options={DisableEnableOptions}
              onChange={props.handleRegisterUpdate}
              colour={COLOURS.default}
              disabled={props.editOff}
            />
            <Display2ValueToggleItem
              register={props.onGetRegisterData(REGS.SPA_LIMIT_OFFSET_ENABLE)}
              icon={IconSpa}
              options={offOnOptions}
              onChange={props.handleRegisterUpdate}
              colour={COLOURS.default}
              disabled={props.editOff}
            />

            <Display2ValueToggleItem
              register={props.onGetRegisterData(REGS.SPA_CHLORINATOR_ENABLE)}
              icon={IconSpa}
              options={DisableEnableOptions}
              onChange={props.handleRegisterUpdate}
              colour={COLOURS.default}
              disabled={props.editOff}
            />
            <DisplayItem register={props.onGetRegisterData(REGS.SPA_LIGHT)} icon={IconLight} />
            <DisplayItem register={props.onGetRegisterData(REGS.SPA_ON_FROM)} icon={IconSpa} />
            <DisplayItem register={props.onGetRegisterData(REGS.SPA_SLEEP_TIMER)} icon={IconSpa} />

            <DisplaySliderItem
              register={props.onGetRegisterData(REGS.SPA_LIMIT_OFFSET)}
              icon={IconThermometer}
              min={0}
              max={40}
              step={2}
              onFormat={formatTemperature}
              onChange={props.handleRegisterUpdate}
              disabled={props.editOff}
            />
            <DisplaySliderItem
              register={props.onGetRegisterData(REGS.SPA_CHLORINATOR_DUTY_CYCLE)}
              icon={IconThermometer}
              min={0}
              max={100}
              step={2}
              onChange={props.handleRegisterUpdate}
              disabled={props.editOff}
            />

            <DisplayPumpSpeed
              register={props.onGetRegisterData(REGS.SPA_SPEED)}
              icon={IconSpeed}
              onChange={props.handleRegisterUpdate}
              disabled={props.editOff}
            />
            <Display2ValueToggleItem
              register={props.onGetRegisterData(REGS.SPA_JETPUMP_ENABLE)}
              icon={IconSpa}
              options={DisableEnableOptions}
              onChange={props.handleRegisterUpdate}
              colour={COLOURS.default}
              disabled={props.editOff}
            />
            <DisplayToggleItem
              register={props.onGetRegisterData(REGS.BLOWER_TIMEOUT_ENABLED)}
              icon={IconBubbles2}
              options={spaBlowerTimeOutOptions}
              onChange={props.handleRegisterUpdate}
              colour={COLOURS.default}
              disabled={props.editOff}
            />
          </Grid>
          <Flex justifyContent="center" alignItems="center" className="space-x-2">
            <Display2ValueToggleItem
              register={props.onGetRegisterData(REGS.SPA_TIMER_ENABLE)}
              options={offOnOptions}
              onChange={props.handleRegisterUpdate}
              colour={COLOURS.default}
              disabled={props.editOff}
            />
            <DisplayTimePickerItem
              register={props.onGetRegisterData(REGS.SPA_TIMER_START_TIME)}
              icon={IconClock}
              onChange={props.onTimesUpdate}
              disabled={props.editOff}
            />
            <DisplayTimePickerItem
              register={props.onGetRegisterData(REGS.SPA_TIMER_STOP_TIME)}
              onChange={props.onTimesUpdate}
              disabled={props.editOff}
            />
          </Flex>
          <Flex justifyContent="center" alignItems="center" className="space-x-2">
            <Display2ValueToggleItem
              register={props.onGetRegisterData(REGS.SPA_TIMER_2_ENABLE)}
              options={offOnOptions}
              onChange={props.handleRegisterUpdate}
              colour={COLOURS.default}
              disabled={props.editOff}
            />
            <DisplayTimePickerItem
              register={props.onGetRegisterData(REGS.SPA_TIMER_2_START_TIME)}
              icon={IconClock}
              onChange={props.onTimesUpdate}
              disabled={props.editOff}
            />
            <DisplayTimePickerItem
              register={props.onGetRegisterData(REGS.SPA_TIMER_2_STOP_TIME)}
              onChange={props.onTimesUpdate}
              disabled={props.editOff}
            />
          </Flex>
        </div>
      </Card>
    </Grid>
  );
};
